import { LOCATION_CHANGE } from 'connected-react-router';

// actions
import * as A from '../actions/mapActions';

const initialState = {
  pins: null,
};

export const reducer = {
  map(state = initialState, action) {
    switch (action.type) {
      case LOCATION_CHANGE:
      case A.clearState.type:
        return initialState;

      case A.getPropertiesMarkers.success:
        return { ...state, pins: action.payload };

      default:
        return state;
    }
  },
};
